import { AbstractService } from '@uniqoders/sdk';

export interface AdminLogFilters {
  file?: string;
  level?: string | string[];
  search?: string;
  limit?: number;
}

export interface AdminLogLine {
  datetime: string;
  env: string;
  level: string;
  message: string;
}

export interface AdminLogResponse {
  files: string[];
  current: string;
  lines: AdminLogLine[];
}

export default class AdminLogService extends AbstractService {
  /**
   * Retrieves admin log files and the parsed tail of the selected file.
   */
  public getLogs(filters: AdminLogFilters = {}): Promise<AdminLogResponse> {
    return this.request({
      method: 'get',
      url: this.buildPath('/admin/logs'),
      params: filters as any,
    });
  }
}
